export default __webpack_public_path__ + "static/fur-f41c8fad514773b5d3de5e388ad031fb.jpg";